import { get,post } from "@/api/request"

// 艺术家主页
export const getClass = params => get("/v1/home/pc/class/auctions", params)
// export const getNews = params => get("/v1/home/pc/news", params)
export const getOther = params => get("/v1/home/pc/statics", params)
export const getRank = params => post("/v1/home/rank/top", params)
export const getSession = params => get("/v1/home/pc/specials", params)
export const getReport = params => post("https://tulu-app.artron.net/report/list", params)
export const getHome = params => get("/news/home", params)
export const getNews = params => get("/news/list", params)
export const getDetails = params => get("/news/detail", params)
// export const getDetails = (url, params) => instance.get("/news/detail", { params })
